// ID4 · Histórico de 6 h INCREMENTAL de la ficha EKH. Funciones puras: sin red ni React.
//
// Contrato con `GET /ekh/vista/camas/{cama}/series?incremental=1&recientes=1[&cursor=…]`:
//  - `incremental.completa`: la respuesta trae TODA la ventana; se reemplaza lo acumulado.
//  - si no, trae las entregas cuya evaluación cambió desde `cursor` menos un margen; se fusionan
//    por clave opaca `k` (una entrega repetida REEMPLAZA a la anterior: no se duplica).
//  - `descartada`: la entrega dejó de pertenecer a esta cama/asignación (se conserva como lápida
//    para que el tope cuente igual que en la lectura completa, pero no aporta puntos).
//  - `requiere_completa`: el incremental se truncó; no hay continuidad acreditada → releer completo.
// La identidad (cama, equipo, asignación y versión) se compara en cada respuesta: si cambia, lo
// acumulado se descarta y se exige una lectura completa. Nada de la cama anterior se arrastra.

export function identidadDe(resp) {
  return [resp?.cama_id ?? "", resp?.device_id ?? "", resp?.asignacion?.id ?? "",
    resp?.asignacion?.version ?? ""].join("|");
}

function orden(a, b) {
  // Misma comparación que Mongo sobre las cadenas ISO de `bridge_received_at`, con la clave como
  // desempate estable entre entregas con la MISMA hora.
  if (a.t < b.t) return -1;
  if (a.t > b.t) return 1;
  return a.k < b.k ? -1 : a.k > b.k ? 1 : 0;
}

/**
 * Aplica una respuesta al estado acumulado.
 * @returns {{estado: object|null, requiereCompleta: boolean}}
 */
export function aplicarRespuesta(estado, resp, { limite = 900 } = {}) {
  const inc = resp?.incremental;
  if (!inc) return { estado: null, requiereCompleta: true };
  const identidad = identidadDe(resp);
  if (!inc.completa && (!estado || estado.identidad !== identidad)) {
    // Un incremental sobre otra identidad no es continuo con lo que se tenía.
    return { estado: null, requiereCompleta: true };
  }
  const entregas = inc.completa ? new Map() : new Map(estado.entregas);
  for (const e of inc.entregas || []) {
    if (!e || !e.k) continue;
    entregas.set(e.k, e);
  }
  const desde = resp.desde || null;
  if (desde) {
    for (const [k, e] of entregas) if (e.t < desde) entregas.delete(k);
  }
  if (entregas.size > limite) {
    const orden_ = [...entregas.values()].sort(orden);
    for (const e of orden_.slice(0, entregas.size - limite)) entregas.delete(e.k);
  }
  return {
    estado: { identidad, entregas, cursor: inc.cursor, desde, hasta: resp.hasta || null },
    requiereCompleta: Boolean(inc.requiere_completa),
  };
}

/** Series por métrica, cronológicas, dentro de [desde, hasta] de la última respuesta. */
export function seriesDe(estado, metricas) {
  const out = {};
  for (const m of metricas) out[m] = [];
  if (!estado) return out;
  const lista = [...estado.entregas.values()].sort(orden);
  for (const e of lista) {
    if (e.descartada) continue;
    if (estado.desde && e.t < estado.desde) continue;
    if (estado.hasta && e.t > estado.hasta) continue;
    for (const m of metricas) {
      const ps = e.puntos?.[m];
      if (ps && ps.length) out[m].push(...ps);
    }
  }
  return out;
}
